<template>
    <q-page padding>
        <div class="row gutter-md desktop-only">
            <div class="col-sm-3">
                <div class="row gutter-sm">
                    <div class="col-12">
                        <points :score="score" :score_statement="user_score_statement" @showStatement="showStatement" :home="true" />
                    </div>

                    <div class="col-12" v-if="showRanking">
                        <ranking @seeAll="seeAll()" />
                    </div>

                    <div class="col-12 col-12 q-mt-md" v-if="has_calendar">
                        <calendar />
                    </div>
                </div>
            </div>

            <div class="col-sm-9">
                <div class="row gutter-sm">
                    <div class="col-12 desktop-only" v-if="home_banners.length > 0">
                        <q-carousel class="text-white shadow-3" height="200px" infinite autoplay>
                            <q-carousel-slide :img-src="banner.image_desktop" v-for="(banner, index) in home_banners" :key="index" class="cursor-pointer background-slide" @click.native="openBanner(banner)" />
                        </q-carousel>
                    </div>

                    <div class="col-8">
                        <div class="row">
                            <div class="col-12" v-if="banners_trainings.length > 0">
                                <q-card class="bg-white">
                                    <q-card-title class="text-center bg-primary text-white">
                                        {{ $t('next_steps')}}
                                    </q-card-title>
                                    <q-card-separator/>
                                    <q-card-main class="text-center relative-position">
                                        <q-carousel class="text-white no-shadow" height="350px" infinite autoplay>
                                            <q-carousel-slide v-for="(banner, index) in banners_trainings" :img-src="banner.image_desktop" :key="index" @click.native="goToTraining(banner)" class="cursor-pointer">
                                                <div class="absolute-bottom custom-caption">
                                                    <div class="q-headline">{{ banner.title }}</div>
                                                </div>
                                            </q-carousel-slide>
                                        </q-carousel>
                                    </q-card-main>
                                </q-card>
                            </div>

                            <div class="col-12">
                                <surveys v-if="surveys.length != 0" :surveys="surveys" @reload_surveys="reloadSurveys" />
                            </div>

                            <div class="col-12 q-mt-md">
                                <badges :badges="badges" :home="true" />
                            </div>

                        </div>
                    </div>

                    <div class="col-4">
                        <div class="row gutter-sm">
                            <div class="col-12" v-if="has_news">
                                <news-feed @openNews="openNews" :news_loaded="news_loaded" :news="news" :home="true" />
                            </div>

                            <div class="col-12" v-if="has_feed">
                                <activities :qtn_active="5" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <q-modal v-model="show_all_ranking" :content-css="{minWidth: '100vw', minHeight: '100vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_all_ranking = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('ranking') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <all-ranking :user_firebase_document_ranking_areas="user_firebase_document_ranking_areas" :user_firebase_document="user_firebase_document" />
                </div>
            </q-modal-layout>
        </q-modal>

        <modal-news  :show_modal="show_news" :id="single_news.id"  @hideModalNews="hideModalNews" />

        <q-modal v-model="show_statement" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_statement = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('points_statement') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <points-statemenet :score_statement="user_score_statement" />
                </div>
            </q-modal-layout>
        </q-modal>
    </q-page>
</template>

<script>
import { db } from 'plugins/vuefire'
import { mapGetters } from 'vuex'
import Points from 'components/profile/Points.vue'
import PointsStatement from 'components/profile/PointsStatement.vue'
import Ranking from 'components/profile/Ranking.vue'
import Calendar from 'components/profile/Calendar.vue'
import AllRanking from 'components/profile/AllRanking.vue'
import Badges from 'components/profile/Badges.vue'
import NewsFeed from 'components/news/NewsFeed'
import Activities from 'components/feed/Activities.vue'
import Surveys from 'components/home/Surveys.vue'
import { required } from 'vuelidate/lib/validators'
import ModalNews from 'components/News'
import { date } from 'quasar'
export default {
    i18nOptions: { namespaces: ['custom', 'feed', 'common', 'news', 'survey'] },

    components: {
        'points': Points,
        'points-statemenet': PointsStatement,
        'ranking': Ranking,
        'calendar': Calendar,
        'all-ranking': AllRanking,
        'badges': Badges,
        'news-feed': NewsFeed,
        'activities': Activities,
        'surveys': Surveys,
        'modal-news': ModalNews
    },

    data() {
        return {
            score: null,
            user_score_statement: [],
            badges: null,
            surveys: [],
            show_all_ranking: false,
            news: [],
            news_loaded: false,
            single_news: [],
            show_news: false,
            banners_trainings: [],
            home_banners: [],
            courses: [],
            show_statement: false,
            tab: 'comments',
            comment: '',
            comments: [],
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            user_firebase_document_ranking_areas: 'common/user_firebase_document_ranking_areas',
            user_firebase_document: 'common/user_firebase_document',
            reload_content: 'common/reload_content',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showRanking() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if (obj) {
                if (obj.has_ranking) return obj.has_ranking
            }
            else return false
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        getPlaceholder() {
            let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) return client.user_avatar_placeholder
			else return ''
        },

        has_calendar() {
            if (this.id_user_client_selected) {
                let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                if (obj)return obj.has_calendar
                else return false
            }
            return false
        },

        has_news() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if (obj && obj.has_news) return true
            else return false
        },

        has_feed() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if (obj && obj.has_feed) return true
            else return false
        }

    },

    methods: {
        fetchAll() {
            this.$q.loading.show()

            this.$axios.get(`/etraining_home/home/`, this.getHeader)
            .then(response => {
                this.score = response.data.user_statistics.user_score ? response.data.user_statistics.user_score.toFixed(2) * 1 : ''
                this.user_score_statement = response.data.user_statistics.user_score_statement
                this.badges = response.data.badges
                this.news = response.data.news
                this.news_loaded = true
                this.banners_trainings = response.data.group_training_banners
                this.home_banners = response.data.home_banners
                this.surveys = response.data.surveys

                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        seeAll() {
            this.show_all_ranking = true
        },

        showStatement() {
            this.show_statement = true
        },

        openNews(item) {
            this.$q.loading.show()

            this.$axios.get(`/etraining_news/news/${item.id}/`, this.getHeader)
            .then(response => {
                this.single_news = response.data
                this.$q.loading.hide()
                this.fetchComments(item.id)
                this.show_news = true
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        goToTraining(item) {
            let target = ''

            switch(item.slug) {
                case 'group_training': target = 'course'
                break
                case 'group_trail':
                case 'group_trails': target = 'trail'
                break
                case 'webcasts':
                case 'webcast':
                case 'webnar':
                case 'webinar': target = 'webcast'
            }

            this.$router.push({ name: target, params: { id: item.id } })
        },

        openBanner(item) {
            if (item.url) {
                if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
                    cordova.InAppBrowser.open(item.url, '_system', 'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no')
                }
                else {
                    window.open(item.url, '_blank')
                }
            }
        },

        reloadSurveys() {
            this.$q.loading.show()

            this.$axios.get(`/etraining_surveys/surveys/`, this.getHeader)
            .then(response => {
                this.surveys = response.data
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        saveComment() {
            this.$v.$touch()
            if (!this.$v.$error) {
                this.$q.loading.show()

                let data = {
                    comment: this.comment
                }

                this.$axios.post(`/etraining_news/news/${this.single_news.id}/set_user_comment/`, data, this.getHeader)
                .then(response => {
                    this.comments = response.data
                    this.comment = ''
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fas fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        fetchComments(id) {
            let data = {
                'page_size': 100,
                'page': 1,
            }
            this.$axios.get(`/etraining_news/news/${id}/get_user_comments/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.comments = response.data.results.map(e => ({ ...e }) )
            })
            .catch(e => {
                console.log(e)
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        hideModalNews() {
            this.show_news = false
        }
    },

    watch: {
        reload_content: function() {
            this.fetchAll()
        }
    },

    created() {
        this.fetchAll()
    },

    validations() {
        return {
            comment: { required },
        }
    }
}
</script>

<style lang="stylus">
.background-slide
    background-position 100% center !important
</style>
